/* istanbul ignore file */
import { stringify } from "query-string";

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { ITenantsResponse, ITenantsRequest, IEnterpriseTenantsRequest } from "./Tenant.api.types";

export const getTenants = async (request: ITenantsRequest): Promise<ITenantsResponse[]> => {
  return (
    await getClientFor(mainApi.name).get<ITenantsResponse[]>("/organizations/tenants/accounts/me", {
      params: request,
      paramsSerializer: p => {
        return stringify(p);
      }
    })
  ).data;
};

export const getEnterpriseTenants = async (request: IEnterpriseTenantsRequest): Promise<ITenantsResponse[]> => {
  return (
    await getClientFor(mainApi.name).get<ITenantsResponse[]>("/organizations/tenants/accounts/me", {
      params: request,
      paramsSerializer: p => {
        return stringify(p);
      }
    })
  ).data;
};
